import React from 'react';
import './Sidebar.css';
import SidebarOptions from './SidebarOptions';


function Sidebar(){
    return(
        <div className='sidebar'>
        <SidebarOptions/>   
      


        </div>

    );

}

export default Sidebar;